import { AbstractControl, ValidationErrors } from "@angular/forms";
import { of } from "rxjs";

/**
 * Validate if the input is a valid date in MM/dd/YYYY format 
 * @returns
 */
export function dateValidator(control: AbstractControl): ValidationErrors | null {
    if (!control.value) {
        return null; // Don't validate empty fields (optional field validation)
    }

    const datePattern = /^(0[1-9]|1[0-2])\/(0[1-9]|[1-2][0-9]|3[01])\/\d{4}$/; // Regex for MM/dd/yyyy format
    const value = control.value;

    if (!datePattern.test(value)) {
        console.log("Invalid date regex");
        return { invalid: true }; // Invalid format
    }

    // Further validation for a valid date
    const [month, day, year] = value.split('/').map((num: string) => parseInt(num, 10));

    // Check if the date is valid
    const date = new Date(year, month - 1, day);
    if (date.getMonth() !== month - 1 || date.getDate() !== day || date.getFullYear() !== year) {
        console.log("Invalid date obj");
        return { invalid: true }; // Invalid date
    }

    return null; // Valid date
};